module.exports = __webpack_public_path__ + "static/4-fd574f2000b0fd0c8f6880539d24ee86.png";